import { ModalDialog, ModalDialogBody, ModalDialogContent } from '@vp/swan'
import classnames from 'classnames'
import { ComponentProps, forwardRef } from 'react'
import { useShowProductCollections } from '~/shared/experiments/ProductCollections/hooks/useShowProductCollections'

export interface PropTypes extends ComponentProps<typeof ModalDialog> {
  ariaLabel?: string
  designId?: string | null
}

export const QuickView = forwardRef<HTMLDialogElement, PropTypes>((props, ref) => {
  const { ariaLabel, children, className, onRequestDismiss, designId, ...rest } = props
  const shouldShowSimilarProducts = useShowProductCollections()

  return (
    <ModalDialog
      ref={ref}
      {...rest}
      className={classnames('quick-view-dialog', className, 'new-quick-view-modal-dialog', {
        'quick-view-similar-templates': !!designId,
        'quick-view-similar-products': !!designId && shouldShowSimilarProducts,
      })}
      variant="standard"
      onRequestDismiss={onRequestDismiss}
    >
      <ModalDialogContent aria-label={ariaLabel} className="new-quick-view-wrapper">
        <ModalDialogBody
          className={classnames('quick-view', {
            'modal-body-height': !designId,
          })}
          mb={0}
        >
          {children}
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
  )
})

QuickView.displayName = 'QuickView'
